import { React, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";

import { Header, LoadingSpinner, VennDiagramComponent, VennDiagramSmallComponent } from "../../Shared";
import { Common } from "../../../helper";
import { DetailedViewTable, PPRMainTable } from "./";
import { ComparisonNames, FilterComparisonMain, FilterNames, CheckAppliedFilter } from "../";

import "../../../assets/stlyes/BigPicture/PPR.scss";

import PPRArrow from "../../../assets/images/VectorPPRArrow.svg";

const BigPicturePPR = () => {
  const [selectedComparison, setSelectedComparision] = useState();
  const [subjects, setSubjects] = useState()
  const [comparisonGroup, setComparisonGroup] = useState();
  const [graphView, listView] = useState(true);
  const [studentDetails, setStudentDetails] = useState();
  const [isLoading, setIsLoading] = useState(false)
  const [generateReport, setGenerateReport] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [selectedClassName, setSelectedClassName_] = useState();
  const [upComing, setUpComing] = useState(false);

  let pupilProgress = useSelector((state) => state.pupilProgress.pupilFilter.info)
  const compSelected = useSelector((state) => state.pupilProgress.BPComparisonSelect)
  const isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)

  const getProgress = (progress) => {
    setSubjects(progress)
    setGenerateReport(true)
    setIsLoading(false)
  }

  const setSelectedClassName = (e) => {
    setSelectedClassName_(e)
  }

  useEffect(() => {
    listView(true);
    setComparisonGroup(Common.AllGroups);
  }, [])

  useEffect(() => {
    CheckAppliedFilter(setSelectedComparision, compSelected, setSelectedFilter, selectedClassName, pupilProgress);
    listView(true);
  }, [subjects])

  return (
    <div className="bigPicturePPR">
      <div className="Page-layout">
        <div className="Page-header">
          <Header />
          <div className="Page-body" style={{ paddingRight: !isNavCollapsed ? "250px" : "75px" }}>
            <div className="PPR-header">
              <div className="Page-name">
                <span className="PPR-name-firstText">{`${Common.BigPicturePageName}`}</span>
                <span className="PPR-name-secondText">{Common.PredictedPassRate}</span>
              </div>
              <div className="PPR-title">
                <span className="PPR-titleText">{Common.PredictedPassRateTitle}</span>
              </div>
              <div className="PPR-subtitle">
                <span className="PPR-subtitleText">{Common.PredictedPassRateSubTitleSecondary}</span>
              </div>
            </div>
            <div className="PPR-comparison">
              <FilterComparisonMain setSubjects={getProgress} number={2} setIsLoading={setIsLoading} isGLD={true} setSelectedClassName={setSelectedClassName} selectedBaseLine={""} setUpComing={setUpComing} isSubject={false} />
            </div>
            <Row style={{ marginTop: "20px" }}>
              <Col sm={12}>
                <div className="bigPictureDataView-PPR">
                  {/* This For Ethnicity of PPR is not yet Cleared by Client till clarification upcoming condition is here */}
                  {upComing ? <h4>{Common.ComingSoon}</h4> : <div>
                    <Row>
                      <Col sm={9}>
                        <div className="title">
                          <span className="dataView-title">{`${Common.PredictedPassRateTitle}: `}</span>
                          <span className="dataView-title">{comparisonGroup}</span>
                        </div>
                        <div className="subtitles1">
                          <span className="dataView-subtitle">{`${Common.Comparison}: `}</span>
                          <span className="dataView-subtitle2">{ComparisonNames(selectedComparison)}</span>
                        </div>
                        <div className="subtitles2">
                          <span className="dataView-subtitle">{`${Common.AppliedFilters}: `}</span>
                          <span className="dataView-subtitle2">{selectedFilter && FilterNames(selectedFilter)}</span>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      {isLoading ? <LoadingSpinner /> : (generateReport ? (<Row style={{ marginTop: "20px" }}><Col sm={12}>
                        <div className="PPR-View">
                          {graphView && subjects ?
                            <Row className="main-ppr">
                              <Col className="sub-ppr">
                                <div className="main-div"><span className="Venn-diagram-title">{`${Common.AllPupils.toUpperCase()} (${subjects?.all.classTotal})`}</span>
                                  <VennDiagramComponent subjects={subjects.all} /></div>
                                <div className="secondary-div">
                                  {subjects.predicted.map((item, index) => (
                                    <div key={index} className="main-venn-div">
                                      <span className="heading">{`${Object.keys(item)} (${Object.values(item)[0].classTotal})`}</span> &nbsp;
                                      <VennDiagramSmallComponent subjects={Object.values(item)[0]} />
                                    </div>
                                  ))}
                                </div>
                              </Col>
                              <Col>
                                {subjects && <PPRMainTable setStudentDetails={setStudentDetails} listView={listView} subject={subjects} />}
                              </Col>
                            </Row> : studentDetails && <Row>
                              <button onClick={() => listView(true)} className="back-button"><img src={PPRArrow} alt="" />&nbsp;{Common.BackToKeyInsight}</button>
                              <Col sm={12}>
                                <DetailedViewTable studentDetails={studentDetails} isPassing={true}/>
                              </Col>
                            </Row>
                          }
                        </div>
                      </Col></Row>) : "")}
                    </Row>
                  </div>}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  )
}

export { BigPicturePPR }